import { ready } from 'jquery';
import 'owl.carousel';
export default {
  init() {
      $('.about-us__cert-slides').owlCarousel({
      loop:true,
      margin:10,
      responsiveClass:true,
      responsive:{
          0:{
              items:1,
              nav:true
          },
          600:{
              items:3,
              nav:false,
              autoplay : true
          },
          1000:{
              items:4,
              nav:true,
              loop:true,
              autoplay : true,
              autoplayTimeout : 2000
          }
      }
    });
      $( document ).ready(function() {
          console.log( "ready! about us" );
      });
  },
};
